import "@fontsource-variable/manrope/wght.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import "./styles/global.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { AuthProvider } from "./lib/auth";
import { appRouter } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: { retry: false },
    queries: { gcTime: 10 * 60_000, refetchOnWindowFocus: false, retry: false },
  },
});

const root = document.getElementById("root");
if (root === null) throw new Error("Uygulama kök öğesi bulunamadı.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={appRouter} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
